import { createAction, createReducer } from "redux-act";
import { reducerRegistry } from "../reducerRegistry";

type MouseLabelText = string | null;

export type MouseLabelState = {
  text: MouseLabelText;
};

export const reducerName = "mouseLabel";

const initialState: MouseLabelState = {
  text: null,
};

export const setMouseLabel = createAction<MouseLabelText>("mouseLabel/set");
export const resetMouseLabel = createAction("mouseLabel/reset");
export const reducer = createReducer({}, initialState);

reducer.on(setMouseLabel, (state, text) => ({
  text,
}));

reducer.on(resetMouseLabel, () => initialState);

reducerRegistry.register(reducerName, reducer);
